module.exports = __webpack_public_path__ + "static/media/616.542b58fd.svg";